export const DASHBOARD_CONTEXTS = Object.freeze({
  BIONEGOCIOS: 'bionegocios'
});

export const DASHBOARD_SECTION_KEYS = Object.freeze({
  FINANCING: 'financing',
  MONITORING: 'monitoring',
  TECHNICAL_ASSISTANCE: 'technical_assistance',
  ATP_SUPERVISION: 'atp_supervision'
});
